const protocolPrefix = 'https://';
export const addProtocolIfNeeded = (baseUrl?: string): string | undefined =>
  !baseUrl || baseUrl.includes(protocolPrefix) ? baseUrl : `${protocolPrefix}${baseUrl}`;
